<template>
  <div>
    <el-form ref="AddForm" :model="AddForm" label-width="100px" :rules="AddRules" style="margin-top:10px;margin-bottom:60px;">
        <el-row type="flex" class="row-bg">
          <el-col :span="7">
            <el-form-item label="类别" prop="b_type">
                <el-select v-model="AddForm.b_type" placeholder="请选择" style="width:100%;">
                  <el-option
                      v-for="item in selectType"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id">
                  </el-option>
                </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row type="flex" class="row-bg">
          <el-col :span="7">
            <el-form-item label="名称" prop="b_name">
                <el-input v-model="AddForm.b_name"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="7">
            <el-form-item label="地区名称" prop="b_area">
                <!-- <el-input v-model="AddForm.b_area"></el-input> -->
                <el-select v-model="AddForm.b_area" placeholder="请选择" style="width:100%;">
                <el-option
                    v-for="item in selectAreaOptions"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                </el-option>
                </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- <el-row type="flex" class="row-bg">
          <el-col :span="14">
            <el-form-item label="地区名称" prop="b_area">
                <el-select v-model="AddForm.b_area" placeholder="请选择">
                <el-option
                    v-for="item in selectAreaOptions"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                </el-option>
                </el-select>
            </el-form-item>
          </el-col>
        </el-row> -->
        <el-row type="flex" class="row-bg">
          <el-col :span="7">
            <el-form-item label="经度" prop="b_lon">
                <el-input v-model="AddForm.b_lon"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="7">
            <el-form-item label="纬度" prop="b_lat">
                <el-input v-model="AddForm.b_lat"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row type="flex" class="row-bg">
          <!-- <el-col :span="7">
            <el-form-item label="代码" prop="b_code">
                <el-input v-model="AddForm.b_code"></el-input>
            </el-form-item>
          </el-col> -->
          <el-col :span="7">
            <el-form-item label="联系方式" prop="b_tel">
                <el-input v-model="AddForm.b_tel"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="7">
            <el-form-item label="服务时间" prop="b_servetime">
                <el-input v-model="AddForm.b_servetime"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row type="flex" class="row-bg">
          <!-- <el-col :span="7">
            <el-form-item label="负责人" prop="b_director">
                <el-select v-model="AddForm.b_director" multiple placeholder="请选择">
                <el-option
                    v-for="item in selectAdminOptions"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                </el-option>
                </el-select>
            </el-form-item>
          </el-col> -->
          <!-- <el-col :span="7">
            <el-form-item label="联系方式" prop="b_tel">
                <el-input v-model="AddForm.b_tel"></el-input>
            </el-form-item>
          </el-col> -->
        </el-row>
        <el-row type="flex" class="row-bg">
          <el-col :span="7">
            <el-form-item label="地址" prop="b_addr">
                <el-input v-model="AddForm.b_addr"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="7">
            <el-form-item label="网站地址" prop="b_url">
                <el-input v-model="AddForm.b_url"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row type="flex" class="row-bg">
          <el-col :span="7">
            <el-form-item label="VR展示地址" prop="b_vrurl">
                <el-input v-model="AddForm.b_vrurl"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row type="flex" class="row-bg">
          <el-col :span="14">
            <el-form-item label="描述" prop="b_desc">
                <el-input type="textarea" :rows="6" v-model="AddForm.b_desc"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row type="flex" class="row-bg">
          <el-col style="width: 210px;">
            <el-form-item label="" prop="b_relatedfloor" style="margin-bottom:10px;">
              <el-checkbox-group v-model="AddForm.b_relatedfloor" @change="handleRelatedfloor">
                <el-checkbox label="一楼一故事"></el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </el-col>
          <el-col :span="7" v-if="AddForm.b_relatedfloor">
             <el-form-item label="关联内容" prop="b_floor" style="margin-bottom:10px;">
                <el-select v-model="AddForm.b_floor" placeholder="请选择" style="width:100%;">
                  <el-option
                      v-for="item in selectFloorOptions"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id">
                  </el-option>
                </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row type="flex" class="row-bg">
          <el-col style="width: 210px;">
            <el-form-item label="" prop="b_relatedrelics">
              <el-checkbox-group v-model="AddForm.b_relatedrelics" @change="handleRelatedrelics">
                <el-checkbox label="文物名录"></el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </el-col>
          <el-col :span="7" v-if="AddForm.b_relatedrelics">
             <el-form-item label="关联内容" prop="b_relics" style="margin-bottom:10px;">
                <el-select v-model="AddForm.b_relics" placeholder="请选择" style="width:100%;">
                  <el-option
                      v-for="item in selectRelicsOptions"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id">
                  </el-option>
                </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row type="flex" class="row-bg">
          <el-col :span="14">
            <el-form-item label="图片" prop="b_cover">
                <!-- <el-input v-model="AddForm.b_cover" disabled></el-input> -->
                <!-- <img :src="AddForm.b_cover" width="150px"> -->
                <el-upload
                    :class="{disabled:uploadDisabled}"
                    :action="uploadAddress"
                    list-type="picture-card"
                    name="file"
                    :limit="1"
                    ref="AddUpload"
                    :http-request="customUploadCover"
                    :on-preview="handleAddPreview"
                    :on-remove="removeAddUpload"
                    :file-list="AddFileList"
                    :before-upload="beforeUploadCover">
                    <i class="el-icon-plus"></i>
                </el-upload>
                    <!-- :on-success="successAddUpload" -->
                <p style="margin:0;color:red">图片格式：".bmp", ".jpg", ".jpeg", ".png"</p>
                <el-dialog :visible.sync="AddPreviewDialogVisible">
                  <img width="100%" :src="AddPreviewDialogImageUrl" alt="">
                </el-dialog>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <el-footer>
        <el-button type="primary" @click="goBack" size="small" icon="el-icon-arrow-left">返回</el-button>
        <el-button type="primary" @click="AddSave('AddForm')" size="small" icon="el-icon-edit-outline">保存</el-button>
      </el-footer>
  </div>
</template>

<script>
// 引入接口
import api from '@/api/api.js'
// 获取token
import { getToken , removeToken } from '@/utils/auth'

export default {
  name: 'componentspage1',
  data() {
      // url验证
      var checkURL = (rule, value, callback) => {        
        if (!value) { 
          callback();          
          //return callback(new Error('VR展示地址不能为空'));         
        } else {          
          const reg = /^((ht|f)tps?):\/\/[\w\-]+(\.[\w\-]+)+([\w\-\.,@?^=%&:\/~\+#]*[\w\-\@?^=%&\/~\+#])?$/
          console.log(reg.test(value));          
          if (reg.test(value)) {            
            callback();         
          } else {            
            return callback(new Error('必须以http/https/ftp/ftps开头,且不能包含双字节符号或非链接特殊字符'));          
          }     
        }
      };
      return {
          AddForm : {
                b_type: '',
                // b_code : '',
                b_lat : '',
                b_id : '',
                b_lon : '',
                // b_director : [],
                b_desc : '',
                b_cover : '',
                b_addr : '',
                b_name : '',
                b_tel : '',
                b_servetime : '',
                b_area : '',
                b_url : '',
                b_vrurl : '',
                b_relatedrelics: false,
                b_relatedfloor: false,
                b_floor: '',
                b_relics: ''
          },
          selectType: [], //类别
          selectAdminOptions : [],
          selectAreaOptions : [], // 地区
          selectFloorOptions: [], //一楼一故事关联ID
          selectRelicsOptions: [], //文物名录
          AddFileList : [],
          AddRules : {
                b_type : [{required: true,message : '请选择场馆类别', trigger: 'blur'}],
                // b_code : [{required: true,message : '请输入代码', trigger: 'blur'}],
                // b_lat : [{required: true,message : '请输入纬度', trigger: 'blur'}],
                // b_lon : [{required: true,message : '请输入经度', trigger: 'blur'}],
                //b_desc : [{required: true,message : '请输入描述', trigger: 'blur'}],
                //b_cover : [{required: true,message : '请上传图片', trigger: 'change'}],
                // b_addr : [{required: true,message : '请输入地址', trigger: 'blur'}],
                b_name : [{required: true,message : '请输入名称', trigger: 'blur'}],
                // b_tel : [{required: true,message : '请输入联系方式', trigger: 'blur'}],
                b_area : [{required: true,message : '请选择地区名称', trigger: 'blur'}],
                b_url : [{required: false, validator: checkURL, trigger: 'blur'}],
                b_vrurl : [{required: false, validator: checkURL, trigger: 'blur'}],
                b_floor: [{required: false, message : '请选择关联内容', trigger: 'change'}],
                b_relics: [{required: false, message : '请选择关联内容', trigger: 'change'}]
          },
          uploadAddress : `${api.dev}/p/main/upload/image`,  // 上传图片的地址
          AddPreviewDialogVisible : false,
          AddPreviewDialogImageUrl : '',
      }
  },
  methods : {
      getHouse(){
        this.$http.get(`${api.dev}/p/main/drop/selectHouse`,{params: {access_token: getToken(), type : 0}}).then(res => {
          if(res.body.code == 200){
            this.selectFloorOptions = res.body.content;
          }
        })
      },
      getRelics(){
        this.$http.get(`${api.dev}/p/main/drop/selectRelics`,{params: {access_token: getToken(), type : 0}}).then(res => {
          if(res.body.code == 200){
            this.selectRelicsOptions = res.body.content;
          }
        })
      },
      handleRelatedfloor(value){
        console.log(value);
        if(value){ //选中一楼一故事
          this.AddRules.b_floor = [{required: true, message : '请选择关联内容', trigger: 'change'}];
        }else{
          this.AddRules.b_floor = [{required: false, message : '请选择关联内容', trigger: 'change'}];
          this.AddForm.b_floor = '';
        }
      },
      handleRelatedrelics(value){
        if(value){ //文物名录
          this.AddRules.b_relics = [{required: true, message : '请选择关联内容', trigger: 'change'}];
        }else{
          this.AddRules.b_relics = [{required: false, message : '请选择关联内容', trigger: 'change'}];
          this.AddForm.b_relics = '';
        }
      },
      getType(){
        this.$http.get(`${api.dev}/p/main/drop/selectVenueType`,{params: {access_token: getToken(), type : 0, fid: -1}}).then(res => {
          if(res.body.code == 200){
            this.selectType = res.body.content;
          }
        })
      },
      goBack() {
        this.$router.back(-1);
      },
      // 获取负责人
      getSelectAdmin() {
        this.$http.get(`${api.dev}/p/main/drop/selectAdmin`,{params: {access_token: getToken(), type : 0}}).then(res => {
          if(res.body.code == 200) {
            this.selectAdminOptions = res.body.content;
          }else if(res.body.code == 500) {
            this.$message({
              message: res.body.msg,
              type: 'error'
            });
            removeToken();
            setTimeout(function () {
              this.$router.push({path: '/login'});
            },2000)
          }
        })
      },
      getSelectArea() {
          this.$http.get(`${api.dev}/p/main/drop/selectArea`,{params: {access_token: getToken(), type : 0}}).then(res => {
                if(res.body.code == 200) {
                    this.selectAreaOptions = res.body.content;
                }else if(res.body.code == 500) {
                    this.$message({
                        message: res.body.msg,
                        type: 'error'
                    });
                    removeToken();
                    setTimeout(function () {
                        this.$router.push({path: '/login'});
                    },2000)
                }
          })
      },
      AddSave(formName) {
          this.$refs[formName].validate((valid) => {
              if(valid) {
                    // 开启加载器
                    const loading = this.$loading({
                        lock: true,
                        text: '正在保存中...',
                        spinner: 'el-icon-loading',
                        background: 'rgba(0, 0, 0, 0.7)'
                    });
                    var formdata = new FormData();
                    formdata.append('access_token',getToken());
                    // formdata.append('b_id',this.AddForm.b_id);
                    formdata.append('b_name',this.AddForm.b_name);
                    formdata.append('b_cover',this.AddForm.b_cover);
                    // formdata.append('b_code',this.AddForm.b_code);
                    formdata.append('b_desc',this.AddForm.b_desc);
                    // formdata.append('b_director',this.AddForm.b_director);
                    // formdata.append('b_director',JSON.stringify(this.AddForm.b_director));
                    formdata.append('b_type',this.AddForm.b_type);
                    formdata.append('b_area',this.AddForm.b_area);
                    formdata.append('b_lon',this.AddForm.b_lon);
                    formdata.append('b_lat',this.AddForm.b_lat);
                    formdata.append('b_addr',this.AddForm.b_addr);
                    formdata.append('b_tel',this.AddForm.b_tel);
                    formdata.append('b_servetime',this.AddForm.b_servetime);
                    formdata.append('b_url',this.AddForm.b_url);
                    formdata.append('b_vrurl',this.AddForm.b_vrurl);
                    formdata.append('b_relatedfloor',this.AddForm.b_relatedfloor);
                    formdata.append('b_relatedrelics',this.AddForm.b_relatedrelics);
                    if(this.AddForm.b_relatedfloor){
                      formdata.append('b_floor',this.AddForm.b_floor);
                    }
                    if(this.AddForm.b_relatedrelics){
                      formdata.append('b_relics',this.AddForm.b_relics);
                    }
                    this.$http.post(`${api.dev}/p/main/venue/save`,formdata,{emulateJSON:true}).then(res => {
                        if(res.body.code == 200) {
                            loading.close();
                            this.$message({
                                message: res.body.msg,
                                type: 'success'
                            });
                            this.$router.back(-1);
                        }else if(res.body.code == 500) {
                            loading.close();
                            this.$message({
                                message: res.body.msg,
                                type: 'error'
                            });
                        }
                    })
              }else {
                  console.log('error submit');
                  return false;
              }
          })
      },
      customUploadCover(options){  
        //console.log(options);
        const formdata = new FormData();
        formdata.append('file', options.file);
        // 添加其他参数
        formdata.append('access_token', getToken());    
        this.$http.post(options.action,formdata,{emulateJSON:true}).then(res => {        
                if(res.body.code==500 || res.body.code==510)
                {   this.$refs.AddUpload.uploadFiles.splice(this.$refs.AddUpload.uploadFiles.indexOf(), 1);//移除预览文件
                  this.$message({
                            message: res.body.msg,
                            type: 'error'
                        });
                    return false;
                }
                else
                {
                  this.AddForm.b_cover= res.body.content; 
                }  
        });       
      },
      // successAddUpload(res,file,fileList) {
      //       this.AddForm.b_cover = res.content;
      // },
      removeAddUpload(file,fileList) {
            this.AddForm.b_cover = '';
      },
      beforeUploadCover(file) {
        const isLt5M = file.size / 1024 / 1024  < 5;
        if (['image/jpg', 'image/jpeg', 'image/bmp','image/png'].indexOf(file.type) == -1) {
            this.$message.error('请上传正确的图片格式');
            return false;
        }
        if (!isLt5M) {
            this.$message.error('上传图片大小不能超过5MB!');
            return false;
        }
      },
      handleAddPreview(file) {
        this.AddPreviewDialogVisible = true;
        this.AddPreviewDialogImageUrl = file.url;
      },
  },
  created() {
      this.getSelectAdmin()
      this.getSelectArea()
      this.getType()
      this.getHouse()
      this.getRelics()
  },
  computed: {
        uploadDisabled:function() {
            return this.AddForm.b_cover != ''
        },
    },
}
</script>

<style lang="stylus" scoped>
.el-footer 
    background-color #A3C0D1;
    color #333;
    line-height 60px;
    position absolute;
    width 100%;
    bottom 0;
    z-index 9999
    margin-left -15px
.el-form-item
    margin-bottom 30px
</style>

